import Search from 'Components/Common/Search/Search';
import useSuggestion from 'Hooks/useSuggestion';
import React from 'react';
import { Col } from 'react-bootstrap';

export default function ArtistSearch(): JSX.Element {
  const {
    artistOptions,
    loadingArtist,
    handleLoadMore,
    handleFocusInput,
    handleEnterPrimary,
    handleClickItemPrimary,
  } = useSuggestion({
    fetchList: ['artist'],
  });

  return (
    <>
      <Col md={4} className="ps-0 pe-1">
        <Search
          label="アーティスト"
          labelMd="3"
          colMd="9"
          placeholder="検索"
          showIcon
          classLabel="px-0 artist-label"
          rowClass="w-100"
          colClass="px-0"
          searchKey="queryArtist"
          onEnter={() => handleEnterPrimary('queryArtist')}
          onClickResult={handleClickItemPrimary}
          options={artistOptions.options || []}
          loading={loadingArtist}
          onLoadMore={() => handleLoadMore('pageArtist')}
          onFocusInput={() => {
            handleFocusInput('queryArtist', 'pageArtist');
          }}
        />
      </Col>
    </>
  );
}
